import { useVersionStore } from "./version.store";

interface StaleNavigationGuardArgs {
	preload: boolean;
	cause: "preload" | "enter" | "stay";
	location: { href: string };
}

// Wired as the root route's beforeLoad. On the root route, cause is "enter"
// only on the initial page load — a freshly loaded bundle is by definition
// current — so only client-side navigations ("stay") are intercepted.
export function staleNavigationGuard({
	preload,
	cause,
	location,
}: StaleNavigationGuardArgs): Promise<void> | void {
	if (preload || cause !== "stay") {
		return;
	}
	if (!useVersionStore.getState().newVersionAvailable) {
		return;
	}

	window.location.assign(location.href);
	// The browser is about to replace the document; never resolve so the SPA
	// transition halts instead of requesting a stale route chunk. Assumes
	// assign() always replaces the document — true here (path-based routing,
	// no hash-only navigations, no beforeunload handlers).
	return new Promise(() => {});
}
